module.exports = __webpack_public_path__ + "static/HelveticaNeueLTW1G-Bd-6a79cb35fa80fcf99fc3dc1bf744675c.woff";